import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { LocalStorageService } from '../local-storage/local-storage.service';
import { inject } from '@angular/core';
import { Router } from '@angular/router';

export const odataInterceptor: HttpInterceptorFn = (req, next) => {
  // Solo interceptamos peticiones al endpoint de OData
  if (!req.url.startsWith(environment.apiOdata + '/odata')) {
    return next(req);
  }

  const router = inject(Router);
  let companyId: string | null = null;

  // Obtenemos el companyId de los parámetros de la ruta actual
  const currentRoute = router.routerState.root;
  let child = currentRoute.firstChild;

  while (child) {
    const params = child.snapshot.params;
    if (params['companyId']) {
      companyId = params['companyId'];
      break;
    }
    child = child.firstChild;
  }

  // Si no hay companyId en la ruta, intentamos obtenerlo del localStorage
  if (!companyId) {
    companyId = LocalStorageService.getPropertyValue(
      LocalStorageService.mojitoLocalStorageKey,
      null
    );
  }

  if (!companyId) return next(req);

  // Manejar URLs
  const separator = req.url.includes('?') ? '&' : '?';
  const modifiedUrl = `${req.url}${separator}companyId=${encodeURIComponent(
    companyId
  )}`;

  // Clonamos la request con la nueva URL
  const modifiedRequest = req.clone({
    url: modifiedUrl,
  });

  return next(modifiedRequest);
};
